import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=8af7b6a2&scoped=true&"
import script from "../assets/js/bookings.js?vue&type=script&lang=js&"
export * from "../assets/js/bookings.js?vue&type=script&lang=js&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=8af7b6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af7b6a2",
  null
  
)

export default component.exports